var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext, useContext, useMemo } from "react";
export var initialState = {
    selectedAccountOption: { label: "", value: "" },
    selectedAccountSummary: undefined,
    isTablet: false,
    data: undefined,
    pageApiError: undefined,
    fieldErrorStrings: [],
    alertsError: false,
    phoneRequiredError: false,
    accountsList: [],
    selectedAccounts: [],
    accountsWithErrors: [],
    handleAddressSelectChange: function (_name, _value) {
        throw new Error("Function not implemented.");
    },
    updateSelectedAccounts: function (_newSelectedAccounts) {
        throw new Error("updateSelectedAccounts not implemented.");
    },
    updateAccountsWithErrors: function (_newAccountsWithErrors) {
        throw new Error("setAccountsWithErrors not implemented.");
    },
    updateFieldErrorStrings: function (_newFieldErrorStrings) {
        throw new Error("setFieldErrorStrings not implemented.");
    },
};
var EditProfileContext = createContext(initialState);
EditProfileContext.displayName = "EditProfileContext";
export var useEditProfileContext = function () {
    var value = useContext(EditProfileContext);
    if (!value) {
        throw new Error("No config");
    }
    return value;
};
var EditProfileContextProvider = function (_a) {
    var state = _a.state, children = _a.children;
    var editProfileState = useMemo(function () { return state; }, [state]);
    return (_jsx(EditProfileContext.Provider, __assign({ value: editProfileState }, { children: children })));
};
export default EditProfileContextProvider;
